import { chargeGet, chargePut, chargeInfo, DelCharge } from '@/api/charge'
export default {
  state: {

  },
  actions: {
    getCharge ({ commit }, payload) {
      return new Promise(resolve => {
        chargeGet(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    infoCharge ({ commit }, payload) {
      return new Promise(resolve => {
        chargeInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveCharge ({ commit }, payload) {
      return new Promise(resolve => {
        chargePut(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelCharge ({ commit }, payload) {
      return new Promise(resolve => {
        DelCharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
